import type { ListProps } from "@mui/material";
import { List } from "@mui/material";
import useLazyRenderList from "../hooks/useLazyRenderList";

interface Props extends ListProps {
  chunkSize?: number;
}

const ListWithLazyRender = ({ chunkSize, children, onScroll, ...other }: Props) => {
  const { loadMore, loadedItems } = useLazyRenderList({ children, chunkSize });

  // When used as MUI Autocomplete's listbox slot, MUI supplies its own onScroll (touch-scroll
  // tracking). Compose it with loadMore so the spread does not silently drop lazy loading.
  const handleScroll: React.UIEventHandler<HTMLUListElement> = (event) => {
    onScroll?.(event);
    loadMore();
  };

  return (
    <List role="listbox" {...other} onScroll={handleScroll}>
      {loadedItems}
    </List>
  );
};

export default ListWithLazyRender;
